<div class="d-flex flex-column">
  <div class="my-4 hgap-2">
    <button class="btn primary">
      {{ 'BUTTON.PRIMARY' | translate }}
    </button>
    <button class="btn primary">
      <span>{{ 'BUTTON.PRIMARY' | translate }}</span>
      <i class="material-icons">keyboard_arrow_right</i>
    </button>
    <button class="btn primary">
      <i class="material-icons">keyboard_arrow_left</i>
      <span>{{ 'BUTTON.PRIMARY' | translate }}</span>
    </button>
    <button class="btn primary text-transform-none">
      <span>{{ 'BUTTON.PRIMARY' | translate }}</span>
    </button>
  </div>

  <div class="my-4 hgap-2">
    <button class="btn secondary">
      {{ 'BUTTON.SECONDARY' | translate }}
    </button>
    <button class="btn secondary">
      <span>{{ 'BUTTON.SECONDARY' | translate }}</span>
      <i class="material-icons">keyboard_arrow_right</i>
    </button>
    <button class="btn secondary">
      <i class="material-icons">keyboard_arrow_left</i>
      <span>{{ 'BUTTON.SECONDARY' | translate }}</span>
    </button>
    <button class="btn secondary text-transform-none">
      {{ 'BUTTON.SECONDARY' | translate }}
    </button>
  </div>

  <div class="my-4 hgap-2">
    <button disabled class="btn">
      {{ 'BUTTON.DISABLED_LABEL' | translate }}
    </button>
    <button disabled class="btn">
      <span>{{ 'BUTTON.DISABLED_LABEL' | translate }}</span>
      <i class="material-icons">keyboard_arrow_right</i>
    </button>
    <button disabled class="btn">
      <i class="material-icons">keyboard_arrow_left</i>
      <span>{{ 'BUTTON.DISABLED_LABEL' | translate }}</span>
    </button>
    <button disabled class="btn text-transform-none">
      {{ 'BUTTON.DISABLED_LABEL' | translate }}
    </button>
  </div>

  <div class="my-4 hgap-2">
    <button class="btn link">
      <span>{{ 'BUTTON.TERTIARY' | translate }}</span>
    </button>
    <button class="btn link underline">
      <span>{{ 'BUTTON.TERTIARY' | translate }}</span>
    </button>
    <button class="btn link">
      <span>{{ 'BUTTON.TERTIARY' | translate }}</span>
      <i class="material-icons">keyboard_arrow_right</i>
    </button>
    <button class="btn link">
      <i class="material-icons">keyboard_arrow_left</i>
      <span>{{ 'BUTTON.TERTIARY' | translate }}</span>
    </button>
    <button class="btn link text-transform-none">
      <span>{{ 'BUTTON.TERTIARY' | translate }}</span>
    </button>
    <button class="btn link" disabled>
      {{ 'BUTTON.TERTIARY' | translate }}
    </button>
  </div>

  <div class="my-4 hgap-2">
    <button class="btn cancel link">
      <span>{{ 'BUTTON.CANCEL' | translate }}</span>
    </button>
    <button class="btn cancel link text-transform-none">
      <span>{{ 'BUTTON.CANCEL' | translate }}</span>
    </button>
  </div>

  <div class="my-4 hgap-2">
    <button class="btn outline outline-primary">
      {{ 'BUTTON.PRIMARY_OUTLINE' | translate }}
    </button>
    <button class="btn outline outline-primary">
      <span> {{ 'BUTTON.PRIMARY_OUTLINE' | translate }}</span>
      <i class="material-icons">keyboard_arrow_right</i>
    </button>
    <button class="btn outline outline-primary">
      <i class="material-icons">keyboard_arrow_left</i>
      <span> {{ 'BUTTON.PRIMARY_OUTLINE' | translate }}</span>
    </button>
  </div>

  <div class="my-4 hgap-2">
    <button class="btn outline outline-secondary">
      {{ 'BUTTON.SECONDARY_OUTLINE' | translate }}
    </button>
    <button class="btn outline outline-secondary">
      <span> {{ 'BUTTON.SECONDARY_OUTLINE' | translate }}</span>
      <i class="material-icons">keyboard_arrow_right</i>
    </button>
    <button class="btn outline outline-secondary">
      <i class="material-icons">keyboard_arrow_left</i>
      <span> {{ 'BUTTON.SECONDARY_OUTLINE' | translate }}</span>
    </button>
    <button class="btn outline outline" disabled>
      {{ 'BUTTON.DISABLED_OUTLINE' | translate }}
    </button>
  </div>

  <h2>contrast</h2>
  <div class="d-flex flex-column contrast-container p-4">
    <div class="my-4 hgap-2">
      <button class="btn contrast contrast-primary">
        {{ 'BUTTON.PRIMARY_CONTRAST' | translate }}
      </button>
      <button class="btn contrast contrast-primary">
        <span>{{ 'BUTTON.PRIMARY_CONTRAST' | translate }}</span>
        <i class="material-icons">keyboard_arrow_right</i>
      </button>
      <button class="btn contrast contrast-primary">
        <i class="material-icons">keyboard_arrow_left</i>
        <span>{{ 'BUTTON.PRIMARY_CONTRAST' | translate }}</span>
      </button>
    </div>
    <div class="my-4 hgap-2">
      <button class="btn contrast contrast-secondary">
        {{ 'BUTTON.SECONDARY_CONTRAST' | translate }}
      </button>
      <button class="btn contrast contrast-secondary">
        <span>{{ 'BUTTON.SECONDARY_CONTRAST' | translate }}</span>
        <i class="material-icons">keyboard_arrow_right</i>
      </button>
      <button class="btn contrast contrast-secondary">
        <i class="material-icons">keyboard_arrow_left</i>
        <span>{{ 'BUTTON.SECONDARY_CONTRAST' | translate }}</span>
      </button>
    </div>
  </div>
  <h3>outline</h3>
  <div class="d-flex flex-column contrast-container p-4">
    <div class="my-4 hgap-2">
      <button class="btn contrast-outline contrast-outline-primary">
        {{ 'BUTTON.PRIMARY_CONTRAST_OUTLINE' | translate }}
      </button>
      <button class="btn contrast-outline contrast-outline-primary">
        <span>{{ 'BUTTON.PRIMARY_CONTRAST_OUTLINE' | translate }}</span>
        <i class="material-icons">keyboard_arrow_right</i>
      </button>
      <button class="btn contrast-outline contrast-outline-primary">
        <i class="material-icons">keyboard_arrow_left</i>
        <span>{{ 'BUTTON.PRIMARY_CONTRAST_OUTLINE' | translate }}</span>
      </button>
    </div>
    <div class="my-4 hgap-2">
      <button class="btn contrast-outline contrast-outline-secondary">
        {{ 'BUTTON.SECONDARY_CONTRAST_OUTLINE' | translate }}
      </button>
      <button class="btn contrast-outline contrast-outline-secondary">
        <span>{{ 'BUTTON.SECONDARY_CONTRAST_OUTLINE' | translate }}</span>
        <i class="material-icons">keyboard_arrow_right</i>
      </button>
      <button class="btn contrast-outline contrast-outline-secondary">
        <i class="material-icons">keyboard_arrow_left</i>
        <span>{{ 'BUTTON.SECONDARY_CONTRAST_OUTLINE' | translate }}</span>
      </button>
    </div>
    <div class="my-4 hgap-2">
      <button class="btn contrast" disabled>
        {{ 'BUTTON.DISABLED_CONTRAST' | translate }}
      </button>
      <button class="btn contrast-outline" disabled>
        {{ 'BUTTON.DISABLED_CONTRAST_OUTLINE' | translate }}
      </button>
    </div>
  </div>
</div>

@for (buttonType of buttonTypes; track buttonType) {
  <ng-container *ngTemplateOutlet="buttonTypeTemplate; context: { $implicit: buttonType, depth: 2 }"></ng-container>
}

<ng-template #title let-title let-depth="depth">
  @if (depth === 2) {
    <h2>{{ title }}</h2>
  }
  @if (depth === 3) {
    <h3>{{ title }}</h3>
  }
  @if (depth === 4) {
    <h4>{{ title }}</h4>
  }
  @if (depth === 5) {
    <h5>{{ title }}</h5>
  }
  @if (depth === 6) {
    <h6>{{ title }}</h6>
  }
</ng-template>

<ng-template #buttonTypeTemplate let-buttonType let-depth="depth">
  <ng-container *ngTemplateOutlet="title; context: { $implicit: buttonType.type, depth: depth }"></ng-container>

  @for (color of buttonType.colors; track color) {
    <ng-container *ngTemplateOutlet="title; context: { $implicit: color, depth: depth + 1 }"></ng-container>
    <div class="row m-0 gap-1" [class.bg-grey]="color.includes('tonal')">
      <div class="col"></div>
      @for (variation of variations; track variation) {
        <div class="col">{{ variation | titlecase }}</div>
      }
      @for (size of buttonType.sizes; track size) {
        <div class="w-100"></div>
        <div class="col">{{ size }}</div>
        @for (variation of variations; track variation) {
          <div class="col">
            <button
              class="btn"
              [class]="buttonType.classes + ' ' + size + ' ' + color + ' ' + variation"
              [disabled]="variation === 'disabled'"
            >
              @if (buttonType.icon) {
                <i class="vitamui-icon vitamui-icon-{{ buttonType.icon }}"></i>
              }
            </button>
          </div>
        }
      }
    </div>
  }

  @for (subButtonType of buttonType.subTypes; track subButtonType) {
    <ng-container
      *ngTemplateOutlet="buttonTypeTemplate; context: { $implicit: computeSubButtonType(buttonType, subButtonType), depth: depth + 1 }"
    ></ng-container>
  }
</ng-template>
